import React, { Component } from "react";
import "../../DocPreview.css";
import { COLOR_LIGHTGRAY, FONT_SIZE, PAGE_PADDING } from '../../Constants/Constants';
import DKCustomFieldSection from "../../DKUILibrary/DKCustomFieldSection";
import DKEInvoiceSection, { eInvoiceSectionPosition } from "../../DKUILibrary/DKEInvoiceSection";
import DKIndiaTaxBreakdown from "../../DKUILibrary/DKIndiaTaxBreakdown";
import DKSignatureSection from "../../DKUILibrary/DKSignatureSection";
import { AddressType, OwnerType } from "../../Helper/AddressParser";
import ComponentManager from "../../Manager/ComponentManager";
import DocumentManager from "../../Manager/DocumentManager";
import { getLocalisedText } from '../../Translate/LanguageManager';
import { HTMLTag } from "../../Utilities/HTMLTag";
import Utility, { getFontSizeClass, getIsFulfillment, getIsGoodsReceipt, getIsJournalEntry, getIsProductDocumentForBuySell, getPageHeight, getVW } from "../../Utilities/Utility";
import TopSectionAboveTableUtility from "../../Utilities/TopSectionAboveTableUtility";
import "./css/Templates.css";

export default class IndiaTemplate6 extends Component { //based on template 1 and also change the position of the address https://deskera.atlassian.net/browse/ZEN-7095

    arabicHeaderWidth = '85%'

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        };
    }

    componentWillReceiveProps(nextProp) {
        this.setState({
            data: nextProp.data,
        });
    }

    //////////////////////////////////////////////////
    //////////////////////////////////////////////////
    //////////////////////////////////////////////////

    addCompanyNameAndDocTypeLabels() {
        return (
            <div className="ColumnDiv" style={{ color: this.state.data.themeColor, width: '100%' }}>
                <div className='ColumnDiv'
                    style={{
                        width: Utility.getIsArabicLang() ? this.arabicHeaderWidth : '100%',
                    }}>
                    {this.state.data.showDocumentType && this.getDocumentType()}
                    {this.state.data.showCompanyName && this.getCompanyName()}
                </div>

                {ComponentManager.getLogoVisibility(this.state.data.showCompanyLogo, this.state.data.isReadOnlyMode, this.state.data.logo) && ComponentManager.getLogo(this.state.data.logo, Utility.convertToPrintScale(80, this.state.data.printScale), {
                    right: 0,
                    top: this.state.data.showEInvoiceSection ? undefined : 0,
                })}
            </div>
        );
    }

    getDocumentType() {
        return <div className="RowDiv"
            style={{
                alignItems: 'center',
                marginBottom: getVW(20),
                flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
            }}>
            <text className={"docFontStyleBold" + getFontSizeClass()}
                style={{
                    color: "rgb(100,100,100)",
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.xxLarge },this.state.data.printScale)
                }}>
                {getLocalisedText(this.state.data.documentType)}
            </text>
        </div>;
    }

    getCompanyName() {
        return (
            <div className="RowDiv"
                style={{
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    width: Utility.getIsArabicLang() ? '100%' : '70%',
                    flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
                }}>
                <text className={"docFontStyleBold" + getFontSizeClass()}
                    style={{
                        ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.large },this.state.data.printScale)
                    }}>
                        {getLocalisedText(this.state.data.tenantInfo ? this.state.data.tenantInfo.name : Utility.getCompanyName(this.state.data))}
                </text>
            </div>
        )
    }

    addTermsNConditionsView() {
        return (
            <div id={HTMLTag.TERMS_NOTE_PREFIX} style={{}}>
                {(this.state.data.showTermsAndCondition && this.state.data.termsAndCondition) &&
                    ComponentManager.getDescriptionSection(
                        Utility.getTermsAndConditionTitle(getLocalisedText('terms_&_condition')),
                        getLocalisedText(this.state.data.termsAndCondition),
                        "100%",
                        this.state.data.themeColor,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        this.state.data.printScale
                    )}

                {((this.state.data.showTermsAndCondition && this.state.data.termsAndCondition) && (this.state.data.showNotes && this.state.data.notes)) && ComponentManager.addVerticalSpace(Utility.convertToPrintScale(20, this.state.data.printScale))}
                {(this.state.data.showNotes && this.state.data.notes) &&
                    ComponentManager.getDescriptionSection(
                        Utility.getNotesTitle(getIsJournalEntry(this.state.data.type) ? getLocalisedText('memo') : getLocalisedText('notes')),
                        getLocalisedText(this.state.data.notes),
                        "100%",
                        "gray",
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        this.state.data.printScale
                    )}
            </div>
        )
    }

    getGenerateDocumentSection() {
        return <div style={{
            paddingBottom: getVW(PAGE_PADDING, true),
            paddingTop: getVW(5),
            width: '100%'
        }}>
            <text className={'docFontStyleBold fontSizeNormal ' + getFontSizeClass()}
                style={{
                    ...Utility.getFontStyleProp({ fontSize: FONT_SIZE.regular },this.state.data.printScale)
                }}>
                {Utility.getGeneratedMessage(this.state.data.type)}
            </text>
        </div>
    }

    render() {
        return (
            <div className='DocumentHolder ColumnDiv' style={{ justifyContent: 'space-between', minHeight: getPageHeight(this.state.data.printScale) }}>
                <div className='parent-width' style={{ width: '100%', paddingBottom: getVW(30) }}>
                    <DKEInvoiceSection
                        data={this.state.data}
                        position={eInvoiceSectionPosition.top}
                    />
                    {this.addCompanyNameAndDocTypeLabels()}
                    {this.state.data.showFrom && this.getCompanyAddressSection()}
                    {ComponentManager.addVerticalSpace(40)}
                    {/* section 2 */}
                    {this.getBillingShippingAndDocumentInfoSection()}
                    {/* section 3 */}
                    {(Utility.getIsShowSourceOfSupply(this.state.data) || Utility.getIsShowDestinationOfSupply(this.state.data) || Utility.getIsShowPlaceOfSupply(this.state.data)) && ComponentManager.addVerticalSpace(20)}
                    {Utility.getIsShowPlaceOfSupply(this.state.data) && this.getPlaceOfSupplyInfoSection()}
                    {(Utility.getIsShowSourceOfSupply(this.state.data) || Utility.getIsShowDestinationOfSupply(this.state.data)) && this.getSourceOfSupplyInfoSection()}
                    {Utility.getIsContainsCustomField('top') && ComponentManager.addVerticalSpace(20)}
                    <DKCustomFieldSection data={this.state.data} onCustomFieldClick={this.props.onCustomFieldClick} style={this.getCustomFieldTableStyle()} customFieldPosition={'top'} isThemeColor />
                    {ComponentManager.addVerticalSpace(20)}
                    {
                        TopSectionAboveTableUtility.getIsTopSectionAboveTableIsVisible() &&
                        <>
                            <div style={{ ...TopSectionAboveTableUtility.getTopSectionWithTableFontStyleProp(undefined, this.state.data.printScale) }}
                                dangerouslySetInnerHTML={{ __html: TopSectionAboveTableUtility.getHtmlString(this.state.data) }} />
                            {ComponentManager.addVerticalSpace(5)}
                        </>
                    }
                    {this.getProductTable()}
                    {Utility.getIsShowAccountProductTable(this.state.data) && ComponentManager.addVerticalSpace(20)}
                    {this.getEditableDocumentTable()}
                    {Utility.getIsContainsCustomField('bottom') && ComponentManager.addVerticalSpace(20)}
                    <DKCustomFieldSection data={this.state.data} onCustomFieldClick={this.props.onCustomFieldClick} style={this.getCustomFieldTableStyle()} customFieldPosition={'bottom'} isThemeColor />
                    {ComponentManager.addVerticalSpace(15)}
                    {getIsProductDocumentForBuySell(this.state.data) && <DKIndiaTaxBreakdown
                        data={this.state.data}
                    />}
                    {ComponentManager.addVerticalSpace(Utility.convertToPrintScale(15, this.state.data.printScale))}
                    {this.state.data.showSignature && ComponentManager.getSignature(this.state.data.signature,this.state.data.printScale)}
                </div>
                <div className='parent-width'>
                    {(getIsFulfillment(this.state.data.type) || getIsGoodsReceipt(this.state.data.type)) && <DKSignatureSection data={this.state.data} onSignatureSectionClicked={this.props.tableClicked} isThemeColor />}
                    {this.addTermsNConditionsView()}
                </div>
                <DKEInvoiceSection
                    data={this.state.data}
                    position={eInvoiceSectionPosition.bottom}
                />
                {Utility.getGeneratedVisibility() && this.getGenerateDocumentSection()}
            </div>
        );
    }

    getBillingShippingAndDocumentInfoSection() {
        return (
            <div
                className="RowDiv"
                style={{
                    alignItems: "flex-start",
                    justifyContent: 'space-between',
                    backgroundColor: "white",
                }}
            >
                {this.getAddressSection()}
                {this.getDocumentInfoSection()}
            </div>
        )
    }
    getPlaceOfSupplyInfoSection() {
        return (
            <div className="RowDiv" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                <div
                    className="RowDiv"
                    style={{
                        alignItems: "flex-start",
                        justifyContent: 'space-between',
                        backgroundColor: "white",
                    }}
                >
                    {this.getPlaceOfSupply()}

                </div> </div>
        )
    }
    getPlaceOfSupply() {
        return <div className='RowDiv' style={{ width: '70%' }}>
            <div className='ColumnDiv' style={{
                width: '40%'
            }}>
                {Utility.getIsShowPlaceOfSupply(this.state.data) && ComponentManager.getDescriptionSection(
                    getLocalisedText('place_of_supply'),
                    this.state.data.placeOfSupply,
                    "100%",
                    this.state.data.themeColor,
                    false,
                    '#000000',
                    getVW(6),
                    true,
                    this.state.data.printScale
                )}
            </div>

        </div>;

    }

    getSourceOfSupplyInfoSection() {
        return (
            <div
                className="RowDiv"
                style={{
                    alignItems: "flex-start",
                    justifyContent: 'space-between',
                    backgroundColor: "white",
                }}
            >
                {this.getSourceOfSupply()}

            </div>
        )
    }
    getSourceOfSupply() {
        return <div className='RowDiv' style={{ width: '70%' }}>
            <div className='ColumnDiv' style={{
                width: '52%'
            }}>
                {Utility.getIsShowSourceOfSupply(this.state.data) && ComponentManager.getDescriptionSection(
                    getLocalisedText('source_of_supply'),
                    this.state.data.sourceOfSupply,
                    "100%",
                    this.state.data.themeColor,
                    false,
                    '#000000',
                    getVW(6),
                    true,
                    this.state.data.printScale
                )}
            </div>
            <div className='ColumnDiv' style={{
                width: '40%'
            }}>
                {Utility.getIsShowDestinationOfSupply(this.state.data) && ComponentManager.getDescriptionSection(
                    getLocalisedText('destination_of_supply'),
                    this.state.data.destinationOfSupply,
                    "100%",
                    this.state.data.themeColor,
                    false,
                    '#000000',
                    getVW(6),
                    true,
                    this.state.data.printScale

                )}
            </div>
        </div>;
    }

    getDocumentInfoSection() {
        return <div
            className="ColumnDiv"
            style={{ width: "30%", backgroundColor: "white" }}
        >
            {this.getDocumentDetailsSection()}
        </div>;
    }

    getDocumentDetailsSection() {
        var documentDetailList = Utility.getDocumentDetailsList(this.state.data)
        return documentDetailList.map(element => {
            var value = ''
            if (element.key !== undefined) {
                value = this.state.data[element.key]
            }
            else if (element.customFieldValue !== undefined) {
                value = element.customFieldValue
            }
            return ComponentManager.getRowValueSection(
                element.label,
                value,
                this.state.data.themeColor,
                undefined,
                undefined,
                undefined,
                this.state.data.printScale
            )
        });
    }

    getAddressSection() {
        return <div className='RowDiv' style={{ width: '70%' }}>
            {
                this.state.data.showClientShipToAddress &&
                <div className='ColumnDiv' style={{
                    width: '40%'
                }}>
                    {this.state.data.showClientShipToAddress && ComponentManager.getDescriptionSection(
                        this.state.data.shipToTitle,
                        Utility.getClientShipToAddress(this.state.data),
                        "100%",
                        this.state.data.themeColor,
                        false,
                        '#000000',
                        getVW(6),
                        Utility.getOwnerType(this.state.data, AddressType.shipTo),
                        this.state.data.printScale
                    )}
                    {/* {ComponentManager.getDescriptionSection(
                    "",
                    this.state.data.customerPhoneNumber,
                    "100%",
                    this.state.data.themeColor
                )}
                {ComponentManager.getDescriptionSection(
                    "",
                    this.state.data.customerGSTIN,
                    "100%",
                    this.state.data.themeColor
                )} */}
                    {this.state.data.showClientShipToAddress && ComponentManager.getDescriptionSection(
                        "",
                        this.state.data.shipToAddressStateCode,
                        "100%",
                        this.state.data.themeColor,
                        false,
                        undefined,
                        0,
                        undefined,
                        this.state.data.printScale
                    )}
                </div>
            }
            {(this.state.data.showClientBillToAddress && this.state.data.showClientShipToAddress) && <div style={{ width: "12%" }} />}
            <div className='ColumnDiv' style={{
                width: '40%'
            }}>
                {this.state.data.showClientBillToAddress && ComponentManager.getDescriptionSection(
                    this.getBillToTitle(),
                    getLocalisedText(Utility.getCompanyName(this.state.data)) + '<br/>' + getLocalisedText(Utility.getCompanyAddress(this.state.data)),
                    "100%",
                    this.state.data.themeColor,
                    false,
                    '#000000',
                    getVW(6),
                    Utility.getOwnerType(this.state.data, AddressType.billTo),
                    this.state.data.printScale
                )}
                {/* {ComponentManager.getDescriptionSection(
                    "",
                    this.state.data.customerPhoneNumber,
                    "100%",
                    this.state.data.themeColor
                )}
                {ComponentManager.getDescriptionSection(
                    "",
                    this.state.data.customerGSTIN,
                    "100%",
                    this.state.data.themeColor
                )} */}
                {this.state.data.showClientBillToAddress && ComponentManager.getDescriptionSection(
                    "",
                    this.state.data.customerStateNameAndCode,
                    "100%",
                    this.state.data.themeColor,
                    false,
                    undefined,
                    0,
                    undefined,
                    this.state.data.printScale
                )}
            </div>
        </div>;
    }

    getBillToTitle() {
        if (this.state.data.billToTitle === 'bill_to') {
            return 'ship_from'
        }
        return this.state.data.billToTitle
    }

    getCompanyAddressSection() {
        return <>
            {ComponentManager.getDescriptionSection(
                "",
                this.state.data.tenantAddress,
                Utility.getIsArabicLang() ? this.arabicHeaderWidth : '40%',
                this.state.data.themeColor,
                false,
                '#000000',
                getVW(6),
                OwnerType.tenant,
                this.state.data.printScale
            )}
            {/* {ComponentManager.getDescriptionSection(
                "",
                this.state.data.companyPhoneNumber,
                Utility.getIsArabicLang() ? this.arabicHeaderWidth : '25%',
                this.state.data.themeColor
            )}
            {ComponentManager.getDescriptionSection(
                "",
                this.state.data.companyGSTIN,
                Utility.getIsArabicLang() ? this.arabicHeaderWidth : '25%',
                this.state.data.themeColor
            )} */}
            {ComponentManager.getDescriptionSection(
                "",
                this.state.data.companyStateNameAndCode,
                Utility.getIsArabicLang() ? this.arabicHeaderWidth : '40%',
                this.state.data.themeColor,
                false,
                undefined,
                0,
                undefined,
                this.state.data.printScale
            )}
        </>
    }

    getEditableDocumentTable() {
        return ComponentManager.getDKDocumentTable(
            this.props.tableColumn,
            this.getTableStyle(),
            this.props.data,
            this.props.tableClicked,
            this.props.stockTableClicked,
            this.props.onUpdateDataCallback,
            this.props.paymentTableClicked,
            this.props.additionalTableCallback,
        )
    }

    getProductTable() {
        if(Utility.getIsShowAccountProductTable(this.state.data)) {
            return ComponentManager.getDKProductTable(
                Utility.getTableColumnForAccountProduct(),
                this.getTableStyle(),
                this.props.data,
                this.props.tableClicked,
                this.props.stockTableClicked,
                this.props.onUpdateDataCallback,
                this.props.paymentTableClicked,
                this.props.additionalTableCallback,
            )
        }
    }

    getTableStyle() {
        let style = DocumentManager.getTableDefaultStyle();
        style.headerTextColor = this.state.data.themeColor;
        style.footerTextColor = this.state.data.themeColor;
        style.headerBorderColor = "#BBBABA";
        style.itemBorderColor = "#BBBABA";
        style.footerBackgroundColor = COLOR_LIGHTGRAY;
        style.footerBorderColor = "#BBBABA";
        return style;
    }

    getCustomFieldTableStyle() {
        let style = {}
        style.columnCount = 3
        style.columnWidths = Utility.getIsArabicLang() ? ['20%', '30%', '50%'] : ['36%', '34%', '30%']
        return style;
    }
}
